module.exports = __webpack_public_path__ + "static/media/Upload.c286ea1b.svg";